// Modal.js
import React, { useEffect } from "react";
import closeIcon from "../../assets/images/close.png";

const Modal = ({ isOpen, onClose, children }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") onClose();
        };
        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] relative z-40">
                <button
                    onClick={onClose}
                    className="absolute top-1 right-3 z-50  hover:text-gray-800"
                    aria-label="Close"
                >
                    <img className="h-5 w-5" src={closeIcon} alt="close" />
                </button>

                {children}
            </div>
        </div>

    );
};

export default Modal;
